import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsNumbers from './SettingsNumbers';

function NumberFormatsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Number Formats"
        subtitle="Document numbering configuration"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />
      <div className="p-6">
        <SettingsNumbers />
      </div>
    </div>
  );
}

export default NumberFormatsPage;
